jQuery(document).ready(function ($) {
    var $fancyboxgallery = $('[data-fancybox^="group-"]');

    if (!$fancyboxgallery.length) return

    $.fancybox.defaults.hash = false;

    $('[data-fancybox^="group-]').each(function () {
        $(this).fancybox({
            loop: false
        });
    });
});

jQuery(document).ready(function ($) {
    var $fancyboxvideo = $('[data-fancybox-video]');

    if (!$fancyboxvideo.length) return

    $('[data-fancybox-video]').each(function () {
        $(this).fancybox({
            youtube: {
                showinfo: 0
            },
            vimeo: {
                color: 'f00'
            }
        });
    });
});